import { render, staticRenderFns } from "./UserDetailsOverview.vue?vue&type=template&id=7bfd4751&"
import script from "./UserDetailsOverview.vue?vue&type=script&lang=js&"
export * from "./UserDetailsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports